import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { ResponseError } from '@clickersphere/core/entities/ResponseError';
import { ExceptionEnum } from '@clickersphere/core/enums/ExceptionEnum';
import UserService, {
  IChangePasswordParams,
} from '@clickersphere/core/services/UserService';
import { useStore } from '../../store';
import { useError } from '../useError';
import useToast from '../useToast';

export function useChangePassword() {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { handleError } = useError();
  const { handleCloseModal } = useStore(
    useShallow((state) => ({
      handleCloseModal: state.modal.handleCloseModal,
    })),
  );

  const {
    mutateAsync: changePasswordAsync,
    isPending: changePasswordIsPending,
  } = useMutation({
    mutationFn: (data: IChangePasswordParams) =>
      UserService.changePassword(data),
    onSuccess: () => {
      toast(t('settings.changePassword.success'), 'success');
      handleCloseModal();
    },
    onError: (error) => {
      if (error instanceof ResponseError) {
        if (error.name === ExceptionEnum.AWS_COGNITO_NOT_AUTHORIZED) {
          toast(
            t('settings.changePassword.errors.currentPassword.invalid'),
            'error',
          );
          return;
        }
        handleError(error);
        return;
      }
      toast(t('errors.global'), 'error');
    },
  });

  return {
    changePasswordAsync,
    changePasswordIsPending,
  };
}
